import { KPI_GRANULARITIES } from './granularities.constant.js';
import { PERIOD_PERMISSIONS } from './period.constant.js';
export const FEATURE_PERMISSIONS = [
    'anonymized',
    'projects',
    'viewProjects',
    'shareProjects',
    'createProjects',
    'innovationSupplier',
    'authUris'
];
export const ACCOUNT_MANAGEMENT_PERMISSIONS = ['*'];
export const PERMISSIONS = [
    ...PERIOD_PERMISSIONS,
    ...KPI_GRANULARITIES,
    ...FEATURE_PERMISSIONS,
    ...ACCOUNT_MANAGEMENT_PERMISSIONS
];
const EXCLUDED_PERMISSIONS = ['authUris', '*'];
export const PERMISSIONS_FILTERED = PERMISSIONS.filter((p) => !EXCLUDED_PERMISSIONS.includes(p));
export const PERMISSIONS_SPECIFIC_RULES = {
    banner: {
        onlyForCountries: ['FRA']
    },
    assortmentTypology: {
        onlyForCountries: ['FRA'],
        onlyForInternalOrganization: true
    },
    productTypology: {
        onlyForCountries: ['FRA'],
        onlyForInternalOrganization: true
    },
    netServiceRate: {
        onlyForCountries: ['FRA']
    },
    nielsenMarketShare: {
        onlyForCountries: ['FRA'],
        onlyForInternalOrganization: true
    },
    possessionZoomPageWithTheoretical: {
        onlyForCountries: ['ESP', 'FRA']
    },
    possessionZoomPage: {
        onlyForCountries: ['ESP', 'FRA']
    },
    nonPossessed: {
        onlyForCountries: ['ESP', 'FRA']
    },
    storeStock: {
        onlyForCountries: ['ESP', 'FRA']
    },
    warehouseStock: {
        onlyForCountries: ['ESP', 'FRA']
    },
    grossServiceRate: {
        onlyForCountries: ['ESP', 'FRA']
    },
    salesPossessionRate: {
        onlyForCountries: ['ESP', 'FRA']
    },
    customerSegmentation: {
        onlyForCountries: ['ESP', 'FRA']
    }
};
//# sourceMappingURL=permissions.constant.js.map